export const COMPONENT_NAME = "wallet-history";
